// PDF React View
import MessageBox from "components/shared-components/MessageBox";
import ReactPdfViewer from "components/shared-components/ReactPdfViewer";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";
import { previewPdfInvoicePos, resetPreviewPdfInvoicePos } from "store/actions";
const PDFViewModal = props => {
  const { isOpen, toggle, dataViewDocument, isAllowDownload } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation(["invoicePos"]);

  const dataFormat = useSelector(state => state.invoicePos);
  const { previewPdfFile } = dataFormat;

  useEffect(() => {
    if (isOpen) {
      dispatch(
        previewPdfInvoicePos(
          dataViewDocument.id,
          dataViewDocument.isPolicy,
          dataViewDocument.isConvert,
          dataViewDocument.isNoneCopy
        )
      );
    } else {
      dispatch(resetPreviewPdfInvoicePos());
    }
  }, [isOpen]);

  const styleDiv = {
    width: "100%",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#8080802b",
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        {/* <ModalHeader toggle={toggle}>
          <Label>Bản hiển thị hóa đơn</Label>
        </ModalHeader> */}
        <ModalBody>
          {previewPdfFile.loading ? (
            <div style={styleDiv}>
              <Spinner color="primary" />
            </div>
          ) : previewPdfFile.error ? (
            <div style={styleDiv}>
              <MessageBox
                variant="danger"
                classMore="d-sm-flex align-items-center justify-content-center gap-1 font-size-18"
              >
                <i className="bx bxs-error-alt"></i>File không còn tồn tại
              </MessageBox>
            </div>
          ) : (
            <React.Fragment>
              <div>
                {previewPdfFile.data && (
                  <React.Fragment>
                    <ReactPdfViewer
                      filePdfUrl={previewPdfFile.data}
                      style={{ height: "75vh" }}
                    />
                  </React.Fragment>
                )}
              </div>
            </React.Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="danger"
            className="me-2"
            onClick={toggle}
          >
            Đóng
          </Button>
          {(dataViewDocument?.isPolicy ||
            dataViewDocument?.isConvert ||
            isAllowDownload ||
            !dataViewDocument?.isNoneCopy) && (
            <Button
              type="button"
              color="success"
              className="me-2 btn-label"
              disabled={!previewPdfFile.data}
              onClick={() => {
                const link = document.createElement("a");
                link.href = previewPdfFile.data;
                link.setAttribute("download", "Invoice.pdf");
                document.body.appendChild(link);
                link.click();
              }}
            >
              <i className="bx bx-download label-icon" />
              {dataViewDocument?.isPolicy
                ? "Download chính sách thu đổi"
                : dataViewDocument?.isConvert
                ? "Download bản chuyển đổi"
                : "Download bản hiển thị"}
            </Button>
          )}
        </ModalFooter>
      </div>
    </Modal>
  );
};

PDFViewModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataViewDocument: PropTypes.any,
  isAllowDownload: PropTypes.bool,
};

export default PDFViewModal;
